import React, { Component } from 'react';
import { connect } from 'react-redux';
import { HeaderContainer } from '../global/HeaderContainer';
import NavContainer from '../global/NavContainer';
import Switcher from './Switcher';
import FooterContainer from '../global/FooterContainer';
import Ad from '../Ad';
import { APP_ENV } from '../../consts';
import { scrollToTopOf, addToWebVitals, flushWebVitals, isValid } from '../../utils';
import '../../css/global.scss';
import { onCLS, onFID, onLCP, onINP, onFCP, onTTFB } from 'web-vitals';



class AppView extends Component {
  constructor(props) {
    super(props);
    this.state = {

    };
    this.dwellSession = null;

    this.startDwellSession = this.startDwellSession.bind(this);
    this.endDwellSession = this.endDwellSession.bind(this);
  }

  fireComscore() {
    self.COMSCORE && COMSCORE.beacon({c1: "2", c2: "39712200"});

    fetch(`/comscore/pageview-candidate?ts=${Date.now()}`, {
      cache: 'no-store',
      mode: 'no-cors',
      keepalive: true
    });
  };

  startDwellSession(article) {
    const { isClient } = this.props;
    if (!article || !article.id) return;

    this.dwellSession = {
      pageLoadTime: Date.now(),
      articleId: article.id,
      url: window.location.href,
      path: window.location.pathname,
      title: document.title,
      referrer: document.referrer,
      hasSent: false,
    };
  }

  endDwellSession(exitType = 'unknown') {
    const session = this.dwellSession;
    if (!session || session.hasSent) return;
    if (typeof window === 'undefined') return;

    const dwellTimeSeconds = Math.round((Date.now() - session.pageLoadTime) / 1000);

    if (dwellTimeSeconds < 5 || dwellTimeSeconds > 1800) {
      session.hasSent = true;
      return;
    }

    if (window.analytics && typeof window.analytics.track === 'function') {
      window.analytics.track('article_dwell_time', {
        article_id: session.articleId,
        url: session.url,
        path: session.path,
        title: session.title,
        dwell_time_seconds: dwellTimeSeconds,
        dwell_time_minutes: Math.round((dwellTimeSeconds / 60) * 10) / 10,
        referrer: session.referrer,
        exit_type: exitType, 
      });
    }

    session.hasSent = true;
  }

  componentDidMount() {
    const { dispatch, pageData, isClient } = this.props;
    // For SSR, isMobile is always true. For client render, isMobile's value is determined by the result of the dispatch below.
    if (typeof window !== 'undefined') {
      window.addEventListener('resize', () => {
        dispatch({
          type: 'MOBILE_DETERMINE',
        });
        dispatch({
          type: 'SHOW_RIGHTRAIL',
        });
      });
      dispatch({
        type: 'MOBILE_DETERMINE',
      });
      dispatch({
        type: 'SHOW_RIGHTRAIL',
      });
    }

    // web vitals
    onLCP(addToWebVitals, {reportAllChanges: true});
    onFCP(addToWebVitals);
    onTTFB(addToWebVitals);
    onCLS(addToWebVitals, {reportAllChanges: true});
    onINP(addToWebVitals);
    onFID(addToWebVitals);


    addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'hidden') {
        flushWebVitals();
        this.endDwellSession('visibilitychange');
      }
    });

    addEventListener('pagehide', () => {
      flushWebVitals();
      this.endDwellSession('pagehide');
    });

    if (typeof window !== 'undefined') {
      window.addEventListener('beforeunload', () => {
        this.endDwellSession('beforeunload');
      });
    }

    const isArticle = pageData.pageType === 'article';
    const article = isArticle ? pageData.article[0] : null;
    if (isArticle && article) {
      this.startDwellSession(article);
    }
  }

  componentDidUpdate(prevProps) {
    const { pageData } = this.props;

    const previousArticle = prevProps.pageData.pageType === 'article' ? prevProps.pageData.article[0] : null;
    const currentArticle = pageData.pageType === 'article' ? pageData.article[0] : null;

    if (previousArticle && currentArticle && previousArticle.id !== currentArticle.id) {
      this.endDwellSession('routechange');
      this.startDwellSession(currentArticle);
    } else if (!previousArticle && currentArticle) {
      this.startDwellSession(currentArticle);
    } else if (previousArticle && !currentArticle) {
      this.endDwellSession('routechange');
    }
    if (!this.props.pageData.isLoading && (prevProps.pageData.pageType !== this.props.pageData.pageType) || ((prevProps.pageData.pageType === "article" && this.props.pageData.pageType === "article") && (prevProps.pageData.article[0].id !== this.props.pageData.article[0].id)) || ((prevProps.pageData.pageType === "vertical" && this.props.pageData.pageType === "vertical") && (prevProps.pageData.category !== this.props.pageData.category))) {
      flushWebVitals();
      onLCP(addToWebVitals, {reportAllChanges: true});
      onFCP(addToWebVitals);
      onTTFB(addToWebVitals);
      onCLS(addToWebVitals, {reportAllChanges: true});
      onINP(addToWebVitals);
      onFID(addToWebVitals);
      this.fireComscore();
    }
  }

  render() {
    const {
      isClient, isMobile, pageData, showLeaderboard,
    } = this.props;
    let showLeaderboardAd = showLeaderboard.showAd !== false;
    const { pageType, category } = pageData;
    const adUnit = showLeaderboard.adUnit;
    const isArticle = pageType === 'article';
    const isVertical = pageType === 'vertical' && category;
    const isHomepage = pageType === 'vertical' && !category;
    const isAdUnitForCurrentPage = (isArticle && adUnit && adUnit.endsWith('/article')) || (isVertical && adUnit && adUnit.endsWith('/homepage')) || (isHomepage && adUnit && adUnit.endsWith('_homepage'));
    let renderLeaderboardAd = showLeaderboardAd && showLeaderboard.adUnit && isAdUnitForCurrentPage;
    
    let pageKey = "page-key";
    if (pageData.pageType === 'article') {
      const id = pageData.article[0].id || 'no-id';
      pageKey = `article-${id}`;
    } else if (pageData.pageType === 'vertical') {
      pageKey = `vertical-${pageData.category || 'home'}`;
    } 

    /*
      To prevent flashes on desktop (i.e. because the mobile layout will render first), we can apply an opacity of 0 in cases where isClient is false
      (i.e. for the SSR). The server-rendered markup is set to the client where, on componentDidMount(), we dispatch an action that updates both
      isMobile (window.innerWidth <= 991) and isClient (true). Now that isClient is true, the div wrapping the App children below will have opacity 1.
    */
    return (
      <div>
        { renderLeaderboardAd
          && <div 
                key={pageKey}
                className="htlad-purewow_leaderboard leaderboard-ad"
                data-unit={adUnit}
                data-targeting='{"slot_name":"purewow_leaderboard"}'></div>
        }
        { (showLeaderboardAd && !renderLeaderboardAd)
          && <div className="dummy-ad leaderboard-ad"></div>
        }
        <HeaderContainer/>
        <NavContainer pageData={pageData}/>

        <div className='content'>
         <Switcher />
        </div>

        <FooterContainer />
      </div>
    );
  }
}

const mapStateToProps = ({
  isClient, isMobile, showLeaderboard, pageData,
}) => ({
  isClient,
  isMobile,
  showLeaderboard,
  pageData,
});

const mapDispatchToProps = dispatch => ({
  dispatch,
});

const App = connect(mapStateToProps, mapDispatchToProps)(AppView);

export default App;
